import { Modal } from "@ucchub/ui";
import AccountConfigForm from "@components/accountConfiguration/AccountConfigForm";
import type { AccountConfigFormProps } from "./AccountConfigForm";
import type { ModalProps as VFModalProps } from "@vfuk/core-modal";

type Props = {
  isOpen: boolean;
  onSubmit: AccountConfigFormProps["onSubmit"];
  onClose?: VFModalProps["onCloseCb"];
  onCancel: () => void;
  isSubmitting: AccountConfigFormProps["isSubmitting"];
  error?: string;
  accountConfigToEdit?: AccountConfigFormProps["accountConfigToEdit"];
};

const AccountConfigFormModal = ({
  isOpen,
  onSubmit,
  onClose,
  onCancel,
  isSubmitting,
  error,
  accountConfigToEdit,
}: Props) => {
  const handleOnCancel = () => {
    onCancel();
  };

  return (
    <Modal
      srName="Account configuration form"
      isOpen={isOpen}
      size={5}
      animate
      isClosable
      onClose={(source) => {
        onClose?.(source);
      }}
    >
      <AccountConfigForm
        onSubmit={onSubmit}
        onCancel={handleOnCancel}
        isSubmitting={isSubmitting}
        error={error}
        accountConfigToEdit={accountConfigToEdit}
      />
    </Modal>
  );
};

export default AccountConfigFormModal;
